import { BSessionStorage } from './bSessionStorage.service';
import { BLocalStorageService } from './bLocalStorage.service';
var BLogoutService = (function () {
    function BLogoutService() {
        this.bSessionStorage = new BSessionStorage();
        this.bLocalStorageService = new BLocalStorageService();
    }
    BLogoutService.prototype.logout = function () {
        this.bSessionStorage.clearSessionStorage();
        this.bLocalStorageService.clear();
        return true;
    };
    return BLogoutService;
}());
export { BLogoutService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bLogout.service.ts.pre-build-optimizer.js